/*# sourceMappingURL=treaty-type.component-A4L3K3OU.css.map */
